import { ReactNode } from 'react';
import { Column } from '@tempmee/react';

interface IShiftOverviewListProps {
  isEmpty: boolean;
  EmptyComponent: ReactNode;
  PaginationComponent?: ReactNode;
  children: ReactNode;
  dataCy?: string;
}

/**
 * Card-list layout for the Shift Overview tabs — the card-based replacement for
 * `DataGrid`. Mirrors the grid's empty/pagination semantics without the column
 * header row.
 *
 * Loading is the caller's: every tab returns its own spinner before rendering this,
 * so an empty `children` here always means "the office has no shifts", never
 * "the rows have not arrived yet".
 */
export const ShiftOverviewList = ({
  isEmpty,
  EmptyComponent,
  PaginationComponent,
  children,
  dataCy,
}: IShiftOverviewListProps) => {
  if (isEmpty) {
    return (
      <Column width="100%" data-cy={dataCy} pb={6}>
        {EmptyComponent}
      </Column>
    );
  }

  return (
    <Column width="100%" gap={6} data-cy={dataCy}>
      {/* Cards keep the block's default max width (672px) and are centered in the tab. */}
      <Column width="100%" align="center" gap={4}>
        {children}
      </Column>
      {PaginationComponent}
    </Column>
  );
};
